import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/styles";
import { Paper, CssBaseline } from "@mui/material";
import routes from "./routes";
import theme from "./theme";

function App() {
  let element = useRoutes(routes);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <Paper>{element}</Paper>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
